"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageService = void 0;
var debounce_1 = require("./debounce");
var throttle_1 = require("./throttle");
var PageService = /** @class */ (function () {
    function PageService() {
        var _this = this;
        this.onWindowResizeHandlers = [];
        this.onWindowResizeThrottleHandlers = [];
        this.onBodyClickHandlers = [];
        this.onPopStateHandlers = [];
        this.onScrollThrottleHandlers = [];
        this.onHashChangeHandlers = [];
        this.onPageLoadHandlers = [];
        this.onTouchStartHandlers = [];
        this.onTouchEndHandlers = [];
        this.ieClass = "ie-active";
        this.ffClass = "ff-active";
        this.iPhoneClass = "iphone-active";
        this.iPadClass = "ipad-active";
        this.touchStartHelper = function (event) {
            _this.onTouchStartHandlers.forEach(function (handler) {
                handler(event);
            });
        };
        this.touchEndHelper = function () {
            _this.onTouchEndHandlers.forEach(function (handler) {
                handler();
            });
        };
    }
    PageService.prototype.Init = function () {
        this.$window = $(window);
        this.$document = $(document);
        this.$body = $(document.body);
        this.DetectBrowser();
        this.$window.on("unload", function () { });
    };
    PageService.prototype.AddOnHashChangeHandler = function (handler) {
        this.onHashChangeHandlers.push(handler);
    };
    PageService.prototype.AddOnPageLoadHandler = function (handler) {
        this.onPageLoadHandlers.push(handler);
    };
    PageService.prototype.AddOnWindowResizeHandler = function (handler) {
        this.onWindowResizeHandlers.push(handler);
    };
    PageService.prototype.AddOnWindowResizeThrottleHandler = function (handler) {
        this.onWindowResizeThrottleHandlers.push(handler);
    };
    PageService.prototype.AddOnBodyClickHandler = function (handler) {
        this.onBodyClickHandlers.push(handler);
    };
    PageService.prototype.AddOnScrollThrottleHandler = function (handler) {
        this.onScrollThrottleHandlers.push(handler);
    };
    PageService.prototype.AddOnTouchStartHandler = function (handler) {
        this.onTouchStartHandlers.push(handler);
    };
    PageService.prototype.AddOnTouchEndHandler = function (handler) {
        this.onTouchEndHandlers.push(handler);
    };
    PageService.prototype.AttachOnTouchStartHandler = function () {
        if (this.onTouchStartHandlers.length) {
            this.$document.on("touchstart", this.touchStartHelper);
        }
    };
    PageService.prototype.AttachOnTouchEndHandler = function () {
        if (this.onTouchEndHandlers.length) {
            this.$document.on("touchend", this.touchEndHelper);
        }
    };
    PageService.prototype.AttachOnScrollThrottleHandler = function () {
        var _this = this;
        if (this.onScrollThrottleHandlers.length) {
            this.$document.on("scroll", (0, throttle_1.throttle)(function (e) {
                _this.ScrollThrottleHelper(e);
            }, 50));
        }
    };
    PageService.prototype.AttachOnHashChangeHandler = function () {
        if (this.onHashChangeHandlers.length) {
            this.$window.on("hashchange", this.hashChangeHelper.bind(this));
        }
    };
    PageService.prototype.AttachOnPageLoadHandler = function () {
        if (this.onPageLoadHandlers.length) {
            this.$window.on("load", this.pageLoadHelper.bind(this));
        }
    };
    PageService.prototype.AttachOnBodyClickHadlers = function () {
        this.onBodyClickHandlers.length && this.$body.on("click tap", this.BodyClickHelper.bind(this));
    };
    PageService.prototype.AddOnPopStateHandler = function (handler) {
        this.onPopStateHandlers.push(handler);
    };
    PageService.prototype.AttachOnPopStateHandlers = function () {
        var _this = this;
        if (this.onPopStateHandlers.length > 0) {
            window.onpopstate = function (event) {
                _this.onPopStateHandlers.forEach(function (handler) {
                    handler(event);
                });
            };
        }
    };
    PageService.prototype.AttachOnWindowResizeHandlers = function () {
        var _this = this;
        this.onWindowResizeHandlers.length && this.$window.on("resize", (0, debounce_1.debounce)(function () {
            _this.WindowResizeHelper();
        })) && this.WindowResizeHelper();
    };
    PageService.prototype.AttachOnWindowResizeThrottleHandlers = function () {
        var _this = this;
        this.onWindowResizeThrottleHandlers.length && this.$window.on("resize", (0, throttle_1.throttle)(function () {
            _this.WindowResizeThrottleHelper();
        }));
    };
    PageService.prototype.DetectBrowser = function () {
        var isIE = window.navigator.userAgent.indexOf("MSIE ") > 0 ||
            !!navigator.userAgent.match(/Trident.*rv\:11\./);
        var isFF = navigator.userAgent.search("Firefox") > -1;
        var isiPad = navigator.userAgent.match(/iPad/i) != null;
        var isiPhone = navigator.userAgent.match(/iPhone/i) != null;
        if (isIE) {
            this.$body.addClass(this.ieClass);
        }
        else if (isFF) {
            this.$body.addClass(this.ffClass);
        }
        else if (isiPad) {
            this.$body.addClass(this.iPadClass);
        }
        else if (isiPhone) {
            this.$body.addClass(this.iPhoneClass);
        }
    };
    PageService.prototype.WindowResizeHelper = function () {
        var _this = this;
        this.windowWidth = this.$window.width();
        this.onWindowResizeHandlers.forEach(function (handler) {
            handler(_this.windowWidth);
        });
    };
    PageService.prototype.WindowResizeThrottleHelper = function () {
        var _this = this;
        this.windowWidth = this.$window.width();
        this.onWindowResizeThrottleHandlers.forEach(function (handler) {
            handler(_this.windowWidth);
        });
    };
    PageService.prototype.BodyClickHelper = function (event) {
        this.onBodyClickHandlers.forEach(function (handler) {
            handler(event);
        });
    };
    PageService.prototype.ScrollThrottleHelper = function (event) {
        this.onScrollThrottleHandlers.forEach(function (handler) {
            handler(event);
        });
    };
    PageService.prototype.hashChangeHelper = function (event) {
        this.onHashChangeHandlers.forEach(function (handler) {
            handler(event);
        });
    };
    PageService.prototype.pageLoadHelper = function () {
        this.onPageLoadHandlers.forEach(function (handler) {
            handler();
        });
    };
    return PageService;
}());
var service = new PageService();
exports.PageService = service;
